import { createContext } from 'react';

const PurchaseOrderManagementContext = createContext({
  data: null,
  invalidate: () => {},
});

export default PurchaseOrderManagementContext;
